import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=c3af3756&scoped=true"
import script from "./privacy.vue?vue&type=script&lang=js"
export * from "./privacy.vue?vue&type=script&lang=js"
import style0 from "./privacy.vue?vue&type=style&index=0&id=c3af3756&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3af3756",
  null
  
)

export default component.exports